import { matchPath } from "react-router";

import { SET_TABLE_CONTEXT } from "../action-types.js";
import { type ReduxDispatch, createReducer } from "../redux-utils.js";
import { pushRoute } from "@/app-utils/route.ts";
import { ENTITY_TYPE } from "@/settings/settings.ts";

/**
 * State definition
 */
export enum TableType {
  None = 1,
  SavedGroup = 2,
  SearchResults = 3,
}

export interface ITableContextState {
  tableType: TableType;
}

const initialState: ITableContextState = {
  tableType: TableType.None,
};

export function isDetailPage(pathname: any) {
  for (const key in ENTITY_TYPE) {
    if (ENTITY_TYPE.hasOwnProperty(key)) {
      // see http://stackoverflow.com/questions/1963102/what-does-the-jslint-error-body-of-a-for-in-should-be-wrapped-in-an-if-statemen
      const groupType: string = ENTITY_TYPE[key];
      if (matchPath(`/${groupType.toLowerCase()}/*`, pathname.toLowerCase())) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Reducers
 */
export default createReducer(initialState, {
  [SET_TABLE_CONTEXT]: (state: ITableContextState, tableType: TableType): ITableContextState => {
    return { ...state, tableType: tableType };
  },
});

export function globalSearchSuggestionSelect(entityId: number, groupType: string) {
  return (dispatch: ReduxDispatch) => {
    // reset the tableContext (important if a saved group is displayed while searching, since this is not a correct context)
    // otherwise we get pagination )
    dispatch({ type: SET_TABLE_CONTEXT, payload: TableType.None });
    // change path
    pushRoute(`/${groupType}/${entityId}`);
  };
}
